import Dialog from 'ui/organisms/dialogs/Dialog/Dialog';
import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';

const DialogKeepResults = ({ t, open, onClose, onSuccess }) => {
  return (
    <Dialog
      isOpen={open}
      onClose={onClose}
      onCancel={onClose}
      onSuccess={onSuccess}
      title={t('assigments:Keep results title')}
      buttonTextSuccess={t('assigments:Yes keep results')}
      size="m"
      className="keep-results-dialog"
    >
      <p>{t('assigments:Keep results text')}</p>
      <ul>
        <li>
          {t('assigments:Keep results item prefix')} <strong>{t('assigments:Keep results state corrected')}</strong> {t('assigments:Keep results item corrected')}
        </li>
        <li>
          {t('assigments:Keep results item prefix')} <strong>{t('assigments:Keep results state uncorrected')}</strong> {t('assigments:Keep results item uncorrected')}
        </li>
        <li>
          {t('assigments:Keep results item prefix')} <strong>{t('assigments:Keep results state not done')}</strong> {t('assigments:Keep results item not done')}
        </li>
        <li>{t('assigments:Keep results item notifications')}</li>
      </ul>
    </Dialog>
  );
};

DialogKeepResults.propTypes = {
  onClose: PropTypes.func,
  onSuccess: PropTypes.func,
  open: PropTypes.bool,
  t: PropTypes.func,
};

DialogKeepResults.defaultProps = {
  onClose: function () {},
  onSuccess: function () {},
  open: false,
};

export default withTranslation(['assigments'])(DialogKeepResults);
